/**
 * 生产报表-效率月报「总体开机率 / 总体稼动率」汇总（与 monthly.vue getReport 732-752 行逻辑一致）
 * @param {Array<Object>} rows equipment_basic_efficiency_report 行数据
 * @returns {{ startUpSumRate: string, jiadongSumRate: string }} 与页面展示相同（一位小数字符串）
 */
export function aggregateEfficiencyOverallRates(rows) {
  if (!rows || rows.length === 0) {
    return { startUpSumRate: '0.0', jiadongSumRate: '0.0' }
  }
  let runDuration = 0
  let idleDuration = 0
  let errorDuration = 0
  let st = 0
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i]
    runDuration += row['runDuration'] != null ? Number(row['runDuration']) : 0
    idleDuration += row['idleDuration'] != null ? Number(row['idleDuration']) : 0
    errorDuration += row['errorDuration'] != null ? Number(row['errorDuration']) : 0
    st += row['st'] != null ? Number(row['st']) : 0
  }
  let startUpSumRate
  if (st) {
    startUpSumRate = (((runDuration + idleDuration + errorDuration) / 1000 / st) * 100).toFixed(1)
  } else {
    startUpSumRate = '0.0'
  }
  const a = runDuration + idleDuration + errorDuration - (idleDuration + errorDuration)
  const b = runDuration + idleDuration + errorDuration
  let jiadongSumRate
  if (a !== 0) {
    jiadongSumRate = ((a / b) * 100).toFixed(1)
  } else {
    jiadongSumRate = '0.0'
  }
  return { startUpSumRate, jiadongSumRate }
}

/**
 * 上月平均 OEE(%)：与页面上「总体开机率」「总体稼动率」展示值（一位小数）相乘后再 /100，结果保留两位小数、上限 100
 */
export function oeePercentFromOverallStrings(startUpSumRate, jiadongSumRate) {
  const su = parseFloat(String(startUpSumRate))
  const jd = parseFloat(String(jiadongSumRate))
  if (!Number.isFinite(su) || !Number.isFinite(jd)) {
    return null
  }
  const oee = (su * jd) / 100
  if (!Number.isFinite(oee) || oee <= 0) {
    return null
  }
  return Number(Math.min(100, oee).toFixed(2))
}
